<div class="ajax-loading"><div class="loading-icon"></div></div>
<section class="page-title">
    <h1>Configuration</h1>
    <div class="employee-code">
        <button mat-raised-button color="primary" class="oms-btn pull-right" (click)="openConfigurationDialog(configurationModel)"> Add Configuration </button>
    </div>
</section>
<mat-card class="card-white mb-4">
    <mat-card-title class="mb-0">
        <div class="card-white-title mb-0 cursor-pointer" [class.advanceSearchFilter]="isAdvanceSearchFilter" (click)="onDisplayFilter(null)">
            <div class="card-user-name">Advance Search or Filter</div>
            <div class="office-hours">
                <a class="box-arrow" (click)="onDisplayFilter($event)" href="javascript:void(0);">&nbsp;</a>
            </div>
        </div>
    </mat-card-title>
    <mat-card-content [hidden]="!isAdvanceSearchFilter" class="mt-3">
        <div class="example-form">
            <div class="form-for-advance-search">
                <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <mat-form-field class="example-full-width">
                        <mat-select #group="ngModel"
                                name="group" [(ngModel)]="configurationSearchModel.groupId" placeholder="Select a Group">
                            <mat-option value="00000000-0000-0000-0000-000000000000">Any Group</mat-option>
                            <mat-option *ngFor="let group of configurationGroupList" [value]="group.groupId">{{group.groupName}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <mat-form-field class="example-full-width">
                        <mat-select #type="ngModel"
                                name="type" [(ngModel)]="configurationSearchModel.configurationTypeCode" placeholder="Select a Description">
                            <mat-option value="">Any Type</mat-option>
                            <mat-option *ngFor="let type of configurationTypeList" [value]="type.code">{{type.description}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <mat-form-field class="example-full-width">
                        <input matInput (keydown.enter)="getConfigurationList()" placeholder="Key" name="configKey" [(ngModel)]="configurationSearchModel.configKey" />
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <mat-form-field class="example-full-width">
                        <input matInput (keydown.enter)="getConfigurationList()" placeholder="Name" name="name" [(ngModel)]="configurationSearchModel.name" />
                    </mat-form-field>
                </div>
                <div class="col-12 d-flex">
                    <button class="mt-2 m-l-10 pull-right me-3" mat-raised-button color="primary" (click)="getConfigurationList()"> Search </button>
                    <button class="mt-2 pull-right" mat-raised-button color="primary" (click)="resetSearch()"> Reset </button>
                </div>
            </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
<mat-card class="card-white matcardheight">
    <mat-card-content>
        <div *ngIf="sortedConfigurationList.length > 0" class="stiky-table-container ps-table">
            <table class="list-table" mat-table matSort (matSortChange)="sortConfiguration($event)" matSortActive="name" 
                    matSortDirection="asc" [matSortDisableClear]="true" [dataSource]="sortedConfigurationList">
                <ng-container matColumnDef="configKey">
                    <th mat-header-cell mat-sort-header="configKey" *matHeaderCellDef> Key </th>
                    <td mat-cell *matCellDef="let element"> 
                        <span>{{element.configKey}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell mat-sort-header="name" *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let element"> 
                        <span>{{element.name }}</span>
                    </td>
                </ng-container>
                 <ng-container matColumnDef="description">
                    <th mat-header-cell mat-sort-header="description" *matHeaderCellDef> Description </th>
                    <td mat-cell *matCellDef="let element"> 
                        <span>{{element.description }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="configurationTypeCode">
                    <th mat-header-cell mat-sort-header="configurationTypeCode" *matHeaderCellDef> Type </th>
                    <td mat-cell *matCellDef="let element"> 
                        <span>{{element.configurationTypeCode}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let element">
                        <ul class="action-items">
                            <li class="view-link">
                                <a href="javascript:void(0)" routerLink="/manageconfiguration" class="me-3" [queryParams]="{productCode: productCode, configurationId:element.configurationId}"><i class="fa fa-cogs"></i></a>
                                <a href="javascript:void(0)" (click)="openCopyConfigurationDialog(element)" class="m-l-5"><i class="fa fa-copy"></i></a>
                            </li>
                        </ul>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <mat-paginator  #paginator [pageSize]="pageSize"  [pageSizeOptions]="[5, 10, 20]" [showFirstLastButtons]="true" [length]="totalSize"
        [pageIndex]="currentPage" (page)="handlePage($event)"></mat-paginator>
        <div *ngIf="sortedConfigurationList.length == 0" class="no-record-found text-center">No record found.</div>
    </mat-card-content>
</mat-card>